import { NavLink, useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import { BsArrowRight } from "react-icons/bs";
import headerWatch from "../../Assets/header-watch.jpg";
import { ProductContext } from "../../Contexts/ProductContext";
import "./HomeStyle.css";

const Home = () => {
  const { productState, filtersDispatch } = useContext(ProductContext);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <header>
        <div className="header-img">
          <img src={headerWatch} alt="watch" />
        </div>
        <div className="header-body">
          <h1>Stay in the moment</h1>
          <p>
            Shop our wide selection of watches today and find the perfect one
            for you.
          </p>
          <NavLink to="/products">
            <button
              onClick={() => filtersDispatch({ type: "setClear", payload: "" })}
            >
              Shop Now
            </button>
          </NavLink>
        </div>
      </header>
      <section className="category-section">
        <div className="category-head">
          <h1>Category</h1>
          <p>Discover more. Good things are waiting for you</p>
        </div>
        <div className="category-container">
          {productState.categories.map(
            ({ _id, image, categoryName, description }) => (
              <div
                key={_id}
                className="category-card"
                onClick={() => {
                  filtersDispatch({ type: "setClear", payload: "" });
                  filtersDispatch({
                    type: "setCategoryFilter",
                    payload: categoryName,
                  });
                  navigate("/products");
                }}
              >
                <div className="category-image">
                  <img src={image} alt={categoryName} />
                </div>
                <div className="category-body">
                  <h1>{categoryName}</h1>
                  <p>{description}</p>
                  <button>
                    see Collection <BsArrowRight />
                  </button>
                </div>
              </div>
            )
          )}
        </div>
      </section>
      <footer>
        <div className="footer-container">
          <p className="footer-head">
            &#169; 2025 Minute. All Rights Reserved.
          </p>
          <div className="footer-policy">
            <NavLink to="/terms-conditions" className="footer-link">
              <span>Terms & Condition</span>
            </NavLink>
            <NavLink to="/shipping-policy" className="footer-link">
              <span>Shipping Policy</span>
            </NavLink>
            <NavLink to="/cancellation-policy" className="footer-link">
              <span>Cancellation Policy</span>
            </NavLink>
            <NavLink to="/privacy-policy" className="footer-link">
              <span>Privacy Policy</span>
            </NavLink>
            <NavLink to="/return-refund-policy" className="footer-link">
              <span>Return & Refund Policy</span>
            </NavLink>
          </div>
        </div>
      </footer>
    </div>
  );
};
export { Home };
